import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import LogListWithPager from './LogListWithPager';

const LogsModal = (props: {
    id: number;
    type: string;
    shouldShowModal: boolean;
    closeModal: () => void;
    userHeader?: string;
}) => {
    return (
        <div>
            <Modal show={props.shouldShowModal} onHide={props.closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{Translate('logs/modal/header/logs')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <LogListWithPager id={props.id} type={props.type} userHeader={props.userHeader} />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={props.closeModal}>
                        {Translate('logs/modal/footer/button-label/close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default LogsModal;
